<app-dialog
  #dialog
  [key]="'vincular-empresa'"
  [action]="'vincular-empresa'"
  [headerTheme]="'simple'"
  [title]="'Vincular empresa e registrar deal'"
  [appendTo]="'body'"
  [maxWidth]="'520px'">
  <!--
    `appAutoFormGroup` é OBRIGATÓRIO junto do `[formGroup]`: o `app-input` não injeta
    `ControlContainer`, ele lê o grupo desta diretiva. Só com o `[formGroup]` os inputs criam
    controles PRÓPRIOS — a tela fica preenchida e `ng-valid`, o formulário do componente
    continua vazio e inválido, e o botão nunca libera. Sem erro no console. Já custou uma
    rodada na modal de usuários do parceiro.
  -->
  <div class="p-4" [formGroup]="form" appAutoFormGroup>
    <!-- A empresa vem escolhida do seletor da aba e não se troca aqui: trocá-la mudaria o
         alvo do vínculo depois de o usuário já ter confirmado qual era. -->
    <div class="row">
      <div class="col-12">
        <label class="modal-vincular__rotulo">Empresa</label>
        <p class="modal-vincular__empresa">{{ empresa?.label }}</p>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-md-7">
        <!-- Mesmo campo da tela Comercial › Registrar Deal: é o mesmo dado, e dois jeitos
             diferentes de digitar valor pretendido na mesma feature seria ruído. -->
        <app-input
          label="Valor pretendido"
          type="number"
          prefix="R$ "
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [required]="true"
          [formGroup]="form"
          controlName="amount" />
      </div>
      <div class="col-12 col-md-5">
        <app-select
          [label]="'Moeda'"
          [options]="moedas"
          formControlName="currencyCode"
          [placeholder]="'Selecione'"></app-select>
      </div>
    </div>

    <!-- O que a ação faz além de vincular, dito de frente: sem isto o usuário interno não
         entende por que apareceu um card novo no board depois de "só vincular". -->
    <div class="row mt-3">
      <div class="col-12">
        <div class="alert alert-info mb-0" role="note">
          Além do vínculo, isto registra um <strong>Deal manual</strong> para esta empresa no
          parceiro — ele aparece no board do Comercial, na etapa Registro. O valor pode ser
          corrigido depois por lá.
        </div>
      </div>
    </div>
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [disabled]="!isFormValid()"
        [isLoading]="gravando"
        [loadingText]="'Vinculando...'"
        [label]="'Vincular'"
        [type]="'button'"
        (sendButtonClick)="submitAction()"></app-button>
    </div>
  </ng-template>
</app-dialog>
